import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        //primary: '#ee44aa',
        primary: '#000000',
        primaryclear: '#939393',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        darkBackground: '#333333',
        darkBackgroundAccent: "#444444"
      },
    },
  },
    lang: {
      locales: { es },
      current: 'es',
    },
});
